// Scrolla il contenitore quando il form è stato inviato
const popupForm = document.querySelector('.popup__content .wpcf7');

const scrollThePopup = function () {
    const popupInner = document.querySelector('.popup__inner');
    if (popupForm) {
        setTimeout(() => {
            popupInner.scrollTop = popupInner.scrollHeight;
        }, 100);
    }
}

popupForm.addEventListener('wpcf7invalid', scrollThePopup, false);
popupForm.addEventListener('wpcf7spam', scrollThePopup, false);
popupForm.addEventListener('wpcf7mailsent', scrollThePopup, false);
popupForm.addEventListener('wpcf7mailfailed', scrollThePopup, false);
popupForm.addEventListener('wpcf7submit', scrollThePopup, false);